__turbopack_context__.v({
  "field": "SettingRow-module__YxHsra__field",
  "label": "SettingRow-module__YxHsra__label",
  "row": "SettingRow-module__YxHsra__row",
});
